/* eslint-disable react/no-danger */
import { Alert, Badge, Box, Group, Paper, Stack, Text } from "@mantine/core";
import { IconAlertTriangle, IconCircleCheck } from "@tabler/icons-react";
import type { ReportIdentityPreview } from "../../../services/prefixService";
import { sanitizeReportFooterHtml } from "../../../utils/sanitize";
import { ReportIdentityLogoPreview } from "./ReportIdentityLogoPreview";

interface ReportIdentityPreviewCardProps {
  preview: ReportIdentityPreview;
}

export function ReportIdentityPreviewCard({
  preview,
}: ReportIdentityPreviewCardProps) {
  const { header, footerHtml } = preview.identity;
  const safeFooterHtml = sanitizeReportFooterHtml(footerHtml);
  const contactLine = [
    header.phone ? `Phone ${header.phone}` : "",
    header.fax ? `Fax ${header.fax}` : "",
  ]
    .filter(Boolean)
    .join("  ");

  return (
    <Paper withBorder p="md">
      <Stack gap="md">
        <Group justify="space-between">
          <Text fw={600}>{preview.targetName}</Text>
          <Badge
            color={preview.isComplete ? "green" : "orange"}
            leftSection={
              preview.isComplete ? (
                <IconCircleCheck size={12} />
              ) : (
                <IconAlertTriangle size={12} />
              )
            }
          >
            {preview.isComplete ? "Complete" : "Needs attention"}
          </Badge>
        </Group>

        {preview.warnings.length > 0 && (
          <Alert color="orange" icon={<IconAlertTriangle size={16} />}>
            {preview.warnings.join(" ")}
          </Alert>
        )}

        <Box>
          <Text size="xs" c="dimmed" fw={600} mb="xs">
            Resolved header
          </Text>
          <Paper withBorder p="md">
            <Group justify="space-between" align="center" wrap="nowrap">
              <ReportIdentityLogoPreview
                logoS3Key={preview.logoS3Key}
                targetName={preview.targetName}
              />
              <Stack gap={2} align="flex-end">
                <Text fw={700}>{header.name}</Text>
                {header.medicalDirector && (
                  <Text size="sm">
                    {header.medicalDirector}, Medical Director
                  </Text>
                )}
                {header.address && <Text size="sm">{header.address}</Text>}
                {contactLine && <Text size="sm">{contactLine}</Text>}
              </Stack>
            </Group>
          </Paper>
        </Box>

        <Box>
          <Text size="xs" c="dimmed" fw={600} mb="xs">
            Resolved footer
          </Text>
          <Paper withBorder p="sm">
            {safeFooterHtml ? (
              <Box
                fz="xs"
                className="report-identity-footer-preview"
                dangerouslySetInnerHTML={{ __html: safeFooterHtml }}
              />
            ) : (
              <Text size="xs" c="dimmed">
                No footer configured.
              </Text>
            )}
          </Paper>
        </Box>
      </Stack>
    </Paper>
  );
}
